<template>
  <list
    :columns="columns"
    :modalCreate="modalCreate"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="false"
    :fields="fields"
    :params="params"
    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    this.itemLink = `business/authors/${this.id}/lessonplans`;
    this.setLink = `business/authors/${this.id}/lessonplans`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: { lessonplan_id: this.id },
      val: [],
      modalCreate: "client_group",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_lessonplan_list",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
        },
        {
          key: "type_display",
          title: "Тип",
          checkbox: false,
        },
        {
          key: "name",
          title: "Название темы",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "locale",
          title: "Язык",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "discipline",
          title: "Предмет",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          object: "title",
        },
        {
          key: "author",
          title: "Автор",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          object: "title",
        },
        {
          key: "course",
          object: "title",
          title: "Класс",
          checkbox: false,
          full: false,
          control: false,
          disableLink: true,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "created_at",
          title: "Создан",
          sortBy: "created_at",
          dateTimeFormat: true,
        },
        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
